import { ApiError, ApiParameter } from "@insite/client-framework/Services/ApiService";
import { fetch } from "@insite/client-framework/ServerSideRendering";

export interface GetResultModel{
    result:any
}

export interface GetPreviewParameter extends ApiParameter{
    Identifier?:string[],
    RoundOffTo?:string,
    RoundDollor?:string,
    PriceLabel?:string,
    Quantity?:string,
    SelectedSize?:string,
    SelectedRugQuantity?:string,
    RoundOffValue?:string,
    AddMsrpColumn?:boolean,
    SheetSize?:string,
    Heading?:string,
    Logo?:string,
    ShowQR?:boolean,
    PriceLabelSecondary?:string,
    PriceLabelTertiary?:string,
    isMarketHangtag?:boolean,
    productType?: string,
    secondaryQuantity?:string,
    TertiaryyQuantity?:string,
    AddTertiaryColumn?:boolean,
    Source?:string
}

export const HangtagPreviewUrl ="api/v2/generateHangtagHtml"

export async function GetHangtagPreview(params:GetPreviewParameter) {
    const response = await fetch(`${HangtagPreviewUrl}`,{
        method:"POST",
        headers:{
            "Content-Type": "application/json",
        },
        body: JSON.stringify(params)
    });

    try{
        const result = response.ok && (await response.json())
        if(!response.ok){
            throw new Error(
                JSON.stringify({
                    status: response.status,
                    errorJson: {
                        message: response.statusText,
                    },
                }),
            )
        }
        return result;
    } catch(error){
        let message: string;
        let errorJson: any;
        if (response.headers.get("Content-Type")?.startsWith("application/json")) {
            errorJson = (await response.json()) as { message: string; exceptionMessage?: string };
            message = errorJson.exceptionMessage ?? errorJson.message;
        } else {
            message = await response.text();
        }
        throw new ApiError(HangtagPreviewUrl, response, message, errorJson);
    }
}